<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg')">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div v-if="dataFetch">
                <p class="text-center mt-5">Loading...</p>
            </div>

            <div v-if="!dataFetch">
                <div class="mobile-ver-top mobile-ver-top-2">
                    <div class="d-flex align-items-center h-100 justify-content-between px-3">
                        <div class="d-flex align-items-center">
                            <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2" v-on:click="goToPage('dashboard_student')">
                                <i class="fa-solid fa-arrow-left"></i>
                            </a>
                            <div class="d-block display-tektur h1 m-0">My Rapor</div>
                        </div>
                        <div v-if="dataRationalization.school_info.disable_form_score == 0">
                            <div class="pe-3" v-if="dataRationalization.id">
                                <div class="hide-767">
                                    <button type="button" class="btn btn-s-1 btn-primary" v-on:click="semester_active === 'tka' ? simpan_nilai_tka() : generateScore()" :disabled="fetch_generate">
                                        <div class="btn-s-1-inner">
                                            <i v-if="fetch_generate" class="fa-solid fa-spin fa-spinner me-2"></i>
                                            <i v-if="!fetch_generate" class="fa-solid fa-save me-2"></i>{{fetch_generate ? 'Harap tunggu..':'Simpan Nilai'}}
                                        </div>
                                    </button>
                                </div>
                                <div class="show-767">
                                    <button type="button" class="btn btn-s-1 btn-sm btn-primary" v-on:click="semester_active === 'tka' ? simpan_nilai_tka() : generateScore()" :disabled="fetch_generate">
                                        <div class="btn-s-1-inner">
                                            <i v-if="fetch_generate" class="fa-solid fa-spin fa-spinner me-2"></i>
                                            <i v-if="!fetch_generate" class="fa-solid fa-save me-2"></i>{{fetch_generate ? 'Harap tunggu..':'Simpan Nilai'}}
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="dataRationalization.id" class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                    <div class="d-block px-md-4 px-3">
                        <div class="row py-3">
                            <div class="col-12 m-0 mb-2" v-if="dataRationalization.graduation_year">
                                <div class="card h-100 m-0">
                                    <div class="card-body">
                                        <div class="d-block text-pink mb-2 display-tektur">Tahun Lulus <a v-if="dataRationalization.users.allow_change_major == 1" href="javascript:void(0)" v-on:click="goToPage('student_settings_major')" style="float: right;">Atur Ulang Tahun Lulus <i class="fa fa-solid fa-edit fa-sm"></i></a> </div>
                                        <div class="d-block">
                                            <div class="font-bold block-ellipsis">{{ dataRationalization.graduation_year }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 m-0 mb-2" v-if="dataRationalization.major_one.length != 0">
                                <div class="card h-100 m-0">
                                    <div class="card-body">
                                        <div class="d-block text-pink mb-2 display-tektur">Pilihan 1 <a v-if="dataRationalization.users.allow_change_major == 1" href="javascript:void(0)" v-on:click="goToPage('student_settings_major')" style="float: right;">Atur Ulang Pilihan <i class="fa fa-solid fa-edit fa-sm"></i></a> </div>
                                        <div class="d-block">
                                            <div class="font-bold block-ellipsis">{{ dataRationalization.major_one.major_fullname }}</div>
                                            <div class="d-block text-sm block-ellipsis">{{ dataRationalization.university_one.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="dataRationalization.major_two.length != 0">
                                <div class="card h-100 m-0 mb-2">
                                    <div class="card-body">
                                        <div class="d-block text-pink mb-2 display-tektur">Pilihan 2 <a v-if="dataRationalization.users.allow_change_major == 1" href="javascript:void(0)" v-on:click="goToPage('student_settings_major')" style="float: right;">Atur Ulang Pilihan <i class="fa fa-solid fa-edit fa-sm"></i></a> </div>
                                        <div class="d-block">
                                            <div class="font-bold block-ellipsis">{{ dataRationalization.major_two.major_fullname }}</div>
                                            <div class="d-block text-sm block-ellipsis">{{ dataRationalization.university_two.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="dataRationalization.major_one.length != 0">
                                <div v-if="dataRationalization.users.account_type == 'free'" class="d-none pt-4 text-muted small border-top mt-4 mb-4 text-center">
                                    Kamu <b>hanya dapat memilih jurusan 1x</b> karena terdaftar sebagai akun gratis.
                                </div>
                            </div>

                            <div class="col-12" v-if="dataRationalization.major_one.length == 0">
                                <div class="card h-100 m-0 mb-2">
                                    <div class="card-body">
                                        <div class="d-block text-center p-md-4">
                                            <div class="d-block text-center">
                                                <div class="d-block mb-2 display-tektur text-md">Kamu belum menentukan pilihan jurusan</div>
                                                <div class="d-block">Silahkan tentukan pilihan jurusan untuk mengisi rapor. Klik tombol dibawah ini untuk atur jurusan.</div>
                                                <div class="d-block">
                                                    <a href="javascript:void(0)" class="btn btn-s-1 btn-primary mt-5" v-on:click="goToPage('student_settings_major')">
                                                        <div class="btn-s-1-inner"><i class="fa-solid fa-pen me-2"></i> Atur Pilihan</div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul class="nav nav-tabs">
                            <li class="nav-item" v-for="(item, index) in semesterTabs" :key="index">
                                <a class="nav-link" :class="item == semester_active ? 'active':''" href="javascript:void(0)" v-on:click="setSemester(item)"><small>{{ getSemesterLabel(item) }}</small></a>
                            </li>
                        </ul>
                    </div>

                    <div v-if="semester_active !== 'tka' && dataRationalization.school_info.disable_form_score == 0" class="d-block pt-3 px-md-4 px-3">
                        <div class="d-block small text-muted mb-2">Isi nilai di file format. Isi "-" untuk mata pelajaran yang Off di semester tersebut, kosongkan jika tidak ingin diubah.</div>
                        <div class="d-flex flex-wrap justify-content-end">
                            <button type="button" class="btn btn-white-naked btn-sm me-2 mb-1" v-on:click="downloadTemplate" :disabled="fetch_import">
                                <i class="fa-solid fa-download me-2"></i>Download Format
                            </button>
                            <button type="button" class="btn btn-white-naked btn-sm mb-1" v-on:click="$refs.importFile.click()" :disabled="fetch_import || fetch_generate">
                                <i class="fa-solid me-2" :class="fetch_import ? 'fa-spin fa-spinner':'fa-file-import'"></i>{{ fetch_import ? 'Mengimpor...':'Import Nilai' }}
                            </button>
                            <input ref="importFile" type="file" class="d-none" accept=".xlsx,.xls" v-on:change="onImportFile">
                        </div>
                    </div>

                    <div v-for="(itemSemester, indexSemester) in semesterTabs" :key="indexSemester" :class="itemSemester == semester_active ? 'd-block':'d-none'">
                        <div class="d-block py-3 px-md-4 px-3">
                            <div class="d-flex justify-content-end mb-1" v-if="dataRationalization.school_info.disable_form_score == 0">
                                <div class="d-block small font-bold pe-3">On/Off</div>
                            </div>
                            <div class="d-block" v-for="(item, index) in getDataSubjectByTab(itemSemester)" :key="index">
                                <div class="d-flex align-items-center overflow-hidden py-3 border-bottom">
                                    <div class="font-bold block-ellipsis w-100">{{item.name}}</div>
                                    <div class="form-group form-style-1 m-0 form-style-1-number-2 flex-shrink-0 ms-4">
                                        <input type="text"
                                            :disabled="dataRationalization.school_info.disable_form_score == 1 || getScoreListByTab(itemSemester)[item.id].active != 1"
                                            class="form-control form-control-number"
                                            v-model="getScoreListByTab(itemSemester)[item.id].score">
                                    </div>

                                    <div v-if="dataRationalization.school_info.disable_form_score == 0" class="form-check form-switch flex-shrink-0 ms-4">
                                        <input class="form-check-input" type="checkbox" :checked="getScoreListByTab(itemSemester)[item.id].active == 1 ? 'checked':''" true-value="1" false-value="0" v-on:change="activeFormInput(itemSemester, item.id)">
                                        <label class="form-check-label"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!dataRationalization.id" data-simplebar class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                    <div class="d-block px-md-4 px-3 pt-md-4 pt-3">
                        <div class="d-block mb-3">
                            <div class="card-body">
                                <div class="d-block text-center p-md-4">
                                    <div class="d-block text-center">
                                        <div class="d-block mb-2 display-tektur text-md">Kamu belum menentukan pilihan jurusan</div>
                                        <div class="d-block">Silahkan tentukan pilihan jurusan untuk mengisi rapor. Klik tombol dibawah ini untuk atur jurusan.</div>
                                        <div class="d-block">
                                            <a href="javascript:void(0)" class="btn btn-s-1 btn-primary mt-5" v-on:click="goToPage('student_settings_major')">
                                                <div class="btn-s-1-inner"><i class="fa-solid fa-pen me-2"></i> Atur Pilihan</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'StudentRapor',
    metaInfo: {
        title: 'Rapor',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    data() {
        return {
            is_disabled_form    : 1,
            fetch_generate      : false,
            fetch_import        : false,
            emptyState         : false,
            dataFetch           : false,
            dataRationalization : {
                school_info : {
                    disable_form_score : 0
                }
            },
            form : {
                id                      : "",
                total_semester          : 5,
                score_passing_grade     : "",
                subject_list            : {},
                score_tka_list          : {},
                generate                : 0
            },
            dataSubject     : [],
            dataSubjectTka  : [],
            semester_active : 1,
            submitted       : false,
            waiting         : false
        }
    },
    computed: {
        semesterTabs: function() {
            let tabs = [];

            for (let index = 1; index <= this.form.total_semester; index++) {
                tabs.push(index);
            }

            // Tab Nilai TKA di-hide sementara
            // tabs.push('tka');

            return tabs;
        }
    },
    created() {
        this.getData();
    },
    methods: {
        activeFormInput: function(semester, subject) {
            const scoreListByTab = this.getScoreListByTab(semester);
            const current = scoreListByTab[subject].active;
            this.$set(scoreListByTab[subject], 'active', Number(current) === 1 ? 0 : 1);
            this.$forceUpdate()
        },
        setSemester: function(params) {
            this.semester_active = params;
        },
        getSemesterLabel: function(item) {
            return item === 'tka' ? 'Nilai TKA' : `Semester ${item}`;
        },
        getDataSubjectByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.dataSubjectTka : this.dataSubject;
        },
        getScoreListByTab: function(itemSemester) {
            return itemSemester === 'tka' ? this.form.score_tka_list : this.form.subject_list[itemSemester];
        },
        initializeSubjectListByKey: function(key) {
            this.form.subject_list[key] = {};

            this.dataSubject.forEach(element => {
                this.form.subject_list[key][element.id] = {
                    id : element.id,
                    score : '',
                    active : 0
                };
            });
        },
        initializeScoreTkaList: function() {
            this.form.score_tka_list = {};

            this.dataSubjectTka.forEach(element => {
                this.form.score_tka_list[element.id] = {
                    id : element.id,
                    score : '',
                    active : 0
                };
            });
        },
        ensureSubjectListStructure: function() {
            if (this.form.subject_list === undefined || this.form.subject_list === null || typeof this.form.subject_list !== 'object') {
                this.form.subject_list = {};
            }

            for (let index = 1; index <= this.form.total_semester; index++) {
                if (this.form.subject_list[index] === undefined) {
                    this.initializeSubjectListByKey(index);
                }
            }

            if (this.form.score_tka_list === undefined || this.form.score_tka_list === null || Object.keys(this.form.score_tka_list).length === 0) {
                this.initializeScoreTkaList();
            } else {
                this.dataSubjectTka.forEach(element => {
                    if (this.form.score_tka_list[element.id] === undefined) {
                        this.form.score_tka_list[element.id] = {
                            id : element.id,
                            score : '',
                            active : 0
                        };
                    }
                });
            }
        },
        goToPage: function (params = null) {
            this.$router.push({
                name: params
            })
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/my_rapor';

            this.dataFetch  = true;                
            this.$http.get(uri).then(res => {
                this.dataFetch              = false;
                this.dataRationalization    = res.data.data;

                this.getSubject();

            });
        },
        getSubject: function() {
            let uri         = process.env.VUE_APP_APIHOST+'subject/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataSubject    = res.data.data;
                this.dataSubjectTka = this.dataSubject.filter(item => Number(item.tka) === 1);

                for (let index = 1; index <= this.form.total_semester; index++) {
                    this.initializeSubjectListByKey(index);
                }

                this.initializeScoreTkaList();

                let datasets = this.dataRationalization;

                for (let key in datasets) {
                    if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                        if (key == 'score_list') {
                            if (datasets[key] !== undefined && datasets[key] !== null && datasets[key] !== "" && typeof datasets[key] === 'object') {
                                this.form.subject_list = datasets[key];
                            }
                            continue;
                        }

                        if (key == 'score_tka_list') {
                            if (datasets[key] !== undefined && datasets[key] !== null && datasets[key] !== "" && typeof datasets[key] === 'object') {
                                this.form.score_tka_list = datasets[key];
                            }
                            continue;
                        }

                        this.form[key] = datasets[key];
                    }
                }

                if ((this.form.score_tka_list === undefined || this.form.score_tka_list === null || Object.keys(this.form.score_tka_list).length === 0)
                    && this.form.subject_list !== undefined && this.form.subject_list.tka !== undefined) {
                    this.form.score_tka_list = this.form.subject_list.tka;
                }

                this.ensureSubjectListStructure();
            });
        },
        getSemesterColumnName: function(semester) {
            return `Semester ${semester}`;
        },
        getSemesterList: function() {
            let list = [];

            for (let semester = 1; semester <= Number(this.form.total_semester); semester++) {
                list.push(semester);
            }

            return list;
        },
        isSubjectActive: function(entry) {
            return entry !== undefined && entry !== null && Number(entry.active) === 1;
        },
        escapeHtml: function(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },
        getScoreEntry: function(semester, subjectId) {
            let scoreList = this.form.subject_list[semester] || {};

            return scoreList[subjectId];
        },
        // Satu sheet: baris = semua mapel, kolom = semester.
        // Sel "-" berarti switch OFF (saat download maupun import).
        downloadTemplate: async function() {
            let semesters = this.getSemesterList();
            let subjects = this.dataSubject;

            if (subjects.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Data mata pelajaran belum tersedia.',
                });
                return;
            }

            const XLSX = await import('xlsx');
            let rows = [['ID', 'Mata Pelajaran'].concat(semesters.map(semester => this.getSemesterColumnName(semester)))];

            subjects.forEach(subject => {
                let row = [subject.id, subject.name];

                semesters.forEach(semester => {
                    let entry = this.getScoreEntry(semester, subject.id);

                    if (!this.isSubjectActive(entry)) {
                        row.push('-');
                        return;
                    }

                    let currentScore = entry.score;
                    let numericScore = Number(currentScore);
                    let isEmpty = currentScore === '' || currentScore === null || currentScore === undefined || !isFinite(numericScore);

                    row.push(isEmpty ? '' : numericScore);
                });

                rows.push(row);
            });

            let worksheet = XLSX.utils.aoa_to_sheet(rows);
            // Kolom ID disembunyikan, dipakai untuk mencocokkan data saat import.
            worksheet['!cols'] = [{ wch: 8, hidden: true }, { wch: 40 }].concat(semesters.map(() => ({ wch: 12 })));

            let workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Nilai Rapor');

            let code = this.dataRationalization.code || 'saya';
            XLSX.writeFile(workbook, `format-nilai-rapor-${code}.xlsx`);
        },
        onImportFile: async function(event) {
            let file = event.target.files[0];
            event.target.value = '';

            if (!file) {
                return;
            }

            this.fetch_import = true;
            let parsed = null;

            try {
                const XLSX = await import('xlsx');
                let workbook = XLSX.read(await file.arrayBuffer());
                parsed = this.parseImportWorkbook(XLSX, workbook);
            } catch (error) {
                this.fetch_import = false;
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'File tidak dapat dibaca. Pastikan menggunakan file format yang sudah di-download.',
                });
                return;
            }

            this.fetch_import = false;

            if (parsed.errors.length > 0) {
                let maxShown = 10;
                let list = parsed.errors.slice(0, maxShown).map(item => `<li>${this.escapeHtml(item)}</li>`).join('');
                let more = parsed.errors.length > maxShown ? `<li>dan ${parsed.errors.length - maxShown} lainnya...</li>` : '';

                this.$swal({
                    icon: 'warning',
                    title: 'Import dibatalkan',
                    html: `<div class="text-start small">Perbaiki data berikut lalu import ulang:<ul class="mt-2 mb-0">${list}${more}</ul></div>`,
                });
                return;
            }

            if (parsed.updates.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Tidak ada nilai yang bisa diimpor. Pastikan kolom semester sudah diisi.',
                });
                return;
            }

            // Ganti objek utuh supaya Vue mendeteksi perubahan nilai.
            let subjectList = JSON.parse(JSON.stringify(this.form.subject_list));
            let totalScore = 0;
            let totalOff = 0;

            parsed.updates.forEach(item => {
                if (subjectList[item.semester] === undefined) {
                    subjectList[item.semester] = {};
                }

                if (subjectList[item.semester][item.id] === undefined) {
                    subjectList[item.semester][item.id] = { id: item.id, score: '', active: 0 };
                }

                let entry = subjectList[item.semester][item.id];

                if (item.off) {
                    if (this.isSubjectActive(entry)) {
                        totalOff++;
                    }
                    entry.active = 0;
                } else {
                    entry.score = String(item.score);
                    entry.active = 1;
                    totalScore++;
                }
            });
            this.form.subject_list = subjectList;

            let successText = `${totalScore} nilai berhasil diimpor dan disimpan!`;
            if (totalOff > 0) {
                successText += ` (${totalOff} mata pelajaran di-Off-kan karena diisi "-")`;
            }

            this.generateScore({
                successText : successText,
                failureHint : 'Nilai dari file sudah dimasukkan ke form. Lengkapi nilai yang masih kosong lalu klik Simpan Nilai.'
            });
        },
        parseImportWorkbook: function(XLSX, workbook) {
            let errors  = [];
            let updates = [];

            let worksheet = workbook.Sheets['Nilai Rapor'] || workbook.Sheets[workbook.SheetNames[0]];
            let rows = worksheet ? XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '', blankrows: false }) : [];
            let header = (rows[0] || []).map(cell => String(cell).trim().toLowerCase());
            let idCol = header.indexOf('id');

            // Cari posisi kolom tiap semester dari header.
            let semesterCols = [];
            this.getSemesterList().forEach(semester => {
                let col = header.indexOf(this.getSemesterColumnName(semester).toLowerCase());

                if (col !== -1) {
                    semesterCols.push({ semester, col });
                }
            });

            if (idCol === -1 || semesterCols.length === 0) {
                errors.push('Kolom ID / Semester tidak ditemukan. Gunakan file format yang sudah di-download.');
                return { errors, updates };
            }

            let subjectNames = {};
            this.dataSubject.forEach(subject => {
                subjectNames[subject.id] = subject.name;
            });

            rows.slice(1).forEach((row, index) => {
                let id = String(row[idCol]).trim();
                let rowNumber = index + 2;

                if (id === '') {
                    return;
                }

                if (subjectNames[id] === undefined) {
                    errors.push(`Baris ${rowNumber}: mata pelajaran tidak dikenali`);
                    return;
                }

                semesterCols.forEach(({ semester, col }) => {
                    let raw = row[col];
                    let text = String(raw).trim();

                    // Kosong = tidak diubah.
                    if (text === '') {
                        return;
                    }

                    // "-" = switch OFF.
                    if (text === '-') {
                        updates.push({ semester, id, off: true });
                        return;
                    }

                    let columnName = this.getSemesterColumnName(semester);
                    let score = typeof raw === 'number' ? raw : Number(text.replace(',', '.'));

                    if (!isFinite(score) || score < 0 || score > 100) {
                        errors.push(`${subjectNames[id]} (${columnName}): nilai "${raw}" tidak valid (harus angka 0-100)`);
                        return;
                    }

                    updates.push({ semester, id, score: Math.round(score * 100) / 100 });
                });
            });

            return { errors, updates };
        },
        generateScore: function(options = {}) {
            this.fetch_generate = true;
            let formData = new FormData();
            formData.append('rationalization_id', this.dataRationalization.id);
            formData.append('code', this.dataRationalization.code);
            formData.append('major_one', this.dataRationalization.major_one.id);
            formData.append('major_one_name', this.dataRationalization.major_one.name);
            formData.append('major_one_group', this.dataRationalization.major_one.group_subject_id);
            formData.append('major_two', this.dataRationalization.major_two.id);
            formData.append('major_two_name', this.dataRationalization.major_two.name);
            formData.append('major_two_group', this.dataRationalization.major_two.group_subject_id);

            for (let key in this.form) {
                if(key == 'subject_list') {
                    formData.append('subject_list', JSON.stringify(this.form.subject_list));
                } else if (key == 'score_tka_list') {
                    formData.append('score_tka_list', JSON.stringify(this.form.score_tka_list));
                } else {
                    formData.append(key, this.form[key]);
                }
            }

            this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/generate-score', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.fetch_generate = false;

                if (response.data.status) {
                    this.$swal({
                        icon: 'success',
                        title: 'Success',
                        text: options.successText || response.data.message,
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            this.form.generate = response.data.generate;
                            this.getData();
                        }
                    });
                } else {
                    let text = response.data.message;
                    if (options.failureHint) {
                        text += ' ' + options.failureHint;
                    }

                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: text,
                    });
                }
                this.waiting = false;
            })
            .catch(() => {
                this.fetch_generate = false;
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
            });
        },
        simpan_nilai_tka: function() {
            this.fetch_generate = true;
            let formData = new FormData();
            formData.append('rationalization_id', this.dataRationalization.id);
            formData.append('code', this.dataRationalization.code);
            formData.append('major_one', this.dataRationalization.major_one.id);
            formData.append('major_one_name', this.dataRationalization.major_one.name);
            formData.append('major_one_group', this.dataRationalization.major_one.group_subject_id);
            formData.append('major_two', this.dataRationalization.major_two.id);
            formData.append('major_two_name', this.dataRationalization.major_two.name);
            formData.append('major_two_group', this.dataRationalization.major_two.group_subject_id);

            formData.append('id', this.form.id);
            formData.append('total_semester', this.form.total_semester);
            formData.append('score_passing_grade', this.form.score_passing_grade);
            formData.append('generate', this.form.generate);
            formData.append('score_tka_list', JSON.stringify(this.form.score_tka_list));

            this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/save-score-tka', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.fetch_generate = false;

                if (response.data.status) {
                    this.$swal({
                        icon: 'success',
                        title: 'Success',
                        text: response.data.message,
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            this.form.generate = response.data.generate;
                            this.getData();
                        }
                    });
                } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                }
                this.waiting = false;
            })
            .catch(function () {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
                return;
            });
        }
    }
}
</script>
